import format from '_shared_/plugins/format';

const mutations = {
  SET_FUND_STATISTICS(state, payload) {
    state.fundStat = {
      AverageCoupon: {
        data: format.formatHelpers.rawPercent(payload.AverageCoupon, 1),
        label: 'Average Coupon'
      },
      AverageLife: {
        data: format.formatHelpers.yearString(payload.AverageLife),
        label: 'Average Life'
      },
      AverageYieldMaturity: {
        data: format.formatHelpers.rawPercent(payload.AverageYieldMaturity, 1),
        label: 'Average Yield To Maturity'
      },
      BSYieldToWorst: {
        data: format.formatHelpers.rawPercent(payload.BSYieldToWorst, 1),
        label: 'Average Yield To Worst'
      },
      EffectiveDuration: {
        data: format.formatHelpers.yearString(payload.EffectiveDuration),
        label: 'Effective Duration'
      },
      FundStatAsOfDate: payload.FundStatAsOfDate,
      BSYieldFlag: payload.BSYieldFlag
    };
  }
};

const getters = {
  getFundStatistics: state => state.fundStat
};

const state = {
  fundStat: null
};


export default {
  state,
  getters,
  mutations
};
